import Vue from 'vue'
import Vuex from 'vuex'
import getPage from '../router/page';
Vue.use(Vuex)

let user = localStorage.getItem("user");

let tabOpenOrder = []; //标签页打开的顺序

/**
 * 记录标签打开顺序，最多记录20个，关闭标签时，会根据顺序激活上一个标签
 * @param name
 */
function addTabOpenOrder(name) {
    let lastOrder = tabOpenOrder[0];
    if (lastOrder != name) {
        tabOpenOrder.unshift(name); //向数组的开头插入元素
        if (tabOpenOrder.length > 10) { //超过20个了，就把最后一个删掉
            tabOpenOrder.pop(); //删除数组的最后一个元素
        }

    }
}

/**
 * 将树形功能展开,并返回一个对象，对象的key是所有的功能key，value是功能对象，
 * 可以根据这个对象，判断有没有权限
 * @param funcs
 */
function expandAllFuncs(funcs, result) {
    //console.log(funcs);
    funcs.forEach(func => {
        result[func.funcKey] = func;
        if (func.children && func.children.length > 0) {
            expandAllFuncs(func.children, result);
        }
    })
    return result;
}

export default new Vuex.Store({
	state: {
		user: user ? JSON.parse(user) : {},
		navs: [], //所有的菜单导航,是树形结构
        expandNavs: {}, //将树形结构展开的功能列表，key是funckey，value是func对象
		tabs: [
		],
        currentTab: "", //关联tab的name
        storageHandlers: [], //localstorage 处理函数，[{key:"xxxx", handler: function}]，在App.vue监听器中处理


    },
	mutations: {
        addStorageHandler(state, handler) {
            let exist = state.storageHandlers.filter(item => item.key == handler.key)[0];
            if (exist != null) {
                exist.handler = handler.handler;
            } else {
                state.storageHandlers.push(handler);
            }
        },
        removeStorageHandler(state, handlerKey) {
            console.debug("remove Handler", handlerKey);
            state.storageHandlers = state.storageHandlers.filter(item => item.key != handlerKey);
        },
	    //更新菜单
        //allList.bigList是指后台返回的全部的列表,没有过滤的
        //allList.smallList是指后台返回的全部列表,过滤掉不展示的数据,比如functype==6是按钮,但这个按钮是跳转页面的
	    setNavs(state, allList) {
	        state.navs = allList.smallList;
	        state.expandNavs = expandAllFuncs(allList.bigList, {});
            //console.log(allList.bigList);
        },
		setUser(state, user) {
			state.user = user;
			localStorage.setItem("user", user ? JSON.stringify(user) : "");
		},
		reLogin(state) { //重新登录

            if (window.location.pathname == "/admin/sso") {
                //单点登录
                let token = window.getUrlParam("t");
                if (token) {
                    window.vue.$ajaxGet("/sso/login/" + token, data => {
                        window.updateLocalToken(data.result.token);
                        window.location.href= "/admin?type=teaching"
                    })
                    return;
                }

            }

			state.user = {};
			localStorage.setItem("user", "");
			this.commit("closeAllTabs");
			window.updateLocalToken("");
		},
        /**
         * 打开一个新标签页
         * @param funcKey functionKey
         * @param attr 传入的数据
         * @param title 标签标题
         * @param allowDuplicate 如果已存在同key的标签，是否允许再打开一个新的。如果否的话，会复用已打开的标签
         */
        openTab(state, {funcKey, attr, title, allowDuplicate}) {
		    let tab = null;
		    if (!allowDuplicate) { //不允许重复，就先从已有里找
                tab = state.tabs.filter(item => item.funcKey == funcKey && item.title == title)[0];
            }
		    if (tab == null) {
		        let page = getPage(funcKey);
                //console.log(funcKey);
                //console.log(state.expandNavs[funcKey]);
                //console.log(state.expandNavs);
		        if (page.isFuncPage && state.expandNavs[funcKey] == null) {
		            window.vue.$showError("您暂时无权限访问该页面");
		            return;
                }
		        tab = {
		            name: new Date().getTime()+"",
                    title: title != null ? title : state.expandNavs[funcKey].name,
                    funcKey: funcKey,
                    page: page.view,
                    attr: {...page.attr, ...attr}
                }
                state.tabs.push(tab);
            } else {
		        tab.attr = {...tab.attr, ...attr};
            }
		    //激活这个tab标
		    state.currentTab = tab.name;
		    addTabOpenOrder(tab.name);
        },
        activeTab(state, tab) {
            state.currentTab = tab.name;
            addTabOpenOrder(tab.name);
        },
        closeTab(state, name) {
            state.tabs = state.tabs.filter(item => item.name != name);
            if (name == state.currentTab) { //如果关了当前标签，就根据打开顺序，找到上一个标签并激活
                let lastTabName, lastTab;
                while((lastTabName = tabOpenOrder[0]) != null) {
                    lastTab = state.tabs.filter(item => item.name == lastTabName)[0];
                    if (lastTab != null) {
                        this.commit("activeTab", {name: lastTab.name});
                        return;
                    } else {
                        tabOpenOrder.shift();
                    }
                }
                //执行到这步，说明记录已经不够用了，
                if (state.tabs.length > 0) {
                    this.commit("activeTab", state.tabs[state.tabs.length -1]);
                }
            }
        },
        closeCurrentTab(state) {
            this.commit("closeTab", state.currentTab);
        },
        closeOtherTabs(state, tab) {
            state.tabs = [tab];
            this.commit("activeTab", tab);
        },
        closeAllTabs(state) {
            state.tabs = [];
        },
        closeLeftTabs(state, index) {
            state.tabs = state.tabs.slice(index);
            if (state.tabs.filter(item => item.name == state.currentTab).length == 0) {
                this.commit("closeCurrentTab");
            }
        },
        closeRightTabs(state, index) {
            state.tabs = state.tabs.slice(0, index+1);
            if (state.tabs.filter(item => item.name == state.currentTab).length == 0) {
                this.commit("closeCurrentTab");
            }
        }


	},
	actions: {},
	modules: {}
})
